import React from 'react'
import styled from 'styled-components/macro'
import {
  color,
  compose,
  fontSize,
  margin,
  textAlign,
  textStyle,
} from 'styled-system'
import { $truncate } from '../../../globalStyles'
import { BadgeWarningSVG } from '../../Icons/Basic'
import { TooltipPositions } from '../Tooltip/Tooltip'
import { PlainTooltip } from '../Tooltip/PlainTooltip/PlainTooltip'

export const FrameworkMissingIcon = styled(BadgeWarningSVG).attrs({
  mr: 'xxxs',
})`
  ${margin}
  margin-bottom: 2px;
  width: 12px;
  height: 12px;
`
export const FrameworkMismatchIcon = styled(BadgeWarningSVG).attrs({
  ml: 'xxxs',
})`
  ${margin}
  width: 12px;
  height: 12px;
`

export const ComplianceFrameworkInfoContainer = styled.div.attrs({
  mb: 'xxs',
})`
  display: flex;
  max-width: 20vw;
  gap: 4px;
  align-items: center;
`

export const ModelComplianceFrameWorks = styled.span.attrs<ModelComplianceFrameworksProps>(
  (props) => ({
    color: 'fill.status.info.extraDark',
    textStyle: 'subtitle.caption',
    fontSize: props.isWarning ? '12px' : '14px',
  }),
)<ModelComplianceFrameworksProps>`
  ${compose(color, textStyle, fontSize, textAlign)}
  ${$truncate}
`

export const ModelComplianceFrameWorkInfo = ({
  isWarning,
  modelComplianceFrameworkNames,
  mismatch,
  modelType,
}: {
  modelComplianceFrameworkNames: string
  isWarning: boolean
  mismatch: boolean
  modelType: string
}): JSX.Element => {
  return (
    <ComplianceFrameworkInfoContainer>
      {isWarning && <FrameworkMissingIcon />}
      <ModelComplianceFrameWorks isWarning={isWarning}>
        {modelComplianceFrameworkNames}
      </ModelComplianceFrameWorks>
      {mismatch && (
        <PlainTooltip
          id="model-compliance-framework-tooltip"
          tooltipBody={`The ${modelType}'s compliance framework does not match the current audit.`}
          placement={TooltipPositions.top}
        >
          <FrameworkMismatchIcon />
        </PlainTooltip>
      )}
    </ComplianceFrameworkInfoContainer>
  )
}

ModelComplianceFrameWorkInfo.defaultProps = {
  mismatch: false,
  error: false,
}

type ModelComplianceFrameworksProps = {
  isWarning?: boolean
}
